import React from 'react';
import Step from '../Step';

/**
 * Pass the given props to all relevant children and return
 * a new children array with the new data.
 *
 * @param  {Array}   children A list of all children.
 * @param  {Object}  props    Extra props to merge with the child props.
 * @return {Array}            A list of children with injected props.
 */
export function buildChildrenWithProps(children, props) {
    let stepsCounter = 0;

    return React.Children.map(children, (child) => {
        const isFunctionalComponent = child && child.type && typeof child.type === 'function';

        // if not a react component or not a valid Component of the WIZARD-STEPS library
        if (!isFunctionalComponent) { return child; }

        let childProps = {};

        if (child.type === Step) {
            const id = child.props.id || stepsCounter,
                title = child.props.title || String(id);

            childProps = { id, title };
            stepsCounter++;
        }

        return React.cloneElement(child, Object.assign({}, child.props, props, childProps));
    });
}
